import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["className", "mimeType", "versions"];
import React from "react";
import useEventListener from "../../util/hooks/useEventListener";
import loadable from "../../loadable";
import { jsx as _jsx } from "react/jsx-runtime";
var Video = loadable(function () {
  return import(/* webpackChunkName: "rich-content" */"../Video");
});
var videoMimeTypeMap = {
  mp4: "video/mp4",
  ts: "video/MP2T",
  webm: "video/webm"
};

/**
 * maps video sources to a react-video compatible source list ([{src, type}])
 *
 * @param {{mp4: string, ts: string, webm: string}} sources
 * @returns {{src: string, type: string}[]}
 */
var mapVersionToSourceList = function mapVersionToSourceList(sources) {
  return Object.entries(sources).reduce(function (agg, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      type = _ref2[0],
      src = _ref2[1];
    return [].concat(_toConsumableArray(agg), [{
      src: src,
      type: videoMimeTypeMap[type]
    }]);
  }, []);
};

/**
 * a wrapper of the video component. Its main purpose is to understand
 * the asset format and to translate it so that the generic video component understands it.
 *
 * @todo remove the facebook think __customPropPleaseFixSoon!
 *
 * @param {import("./index").AssetVideoProps} param0
 */
export var AssetVideo = function AssetVideo(_ref3) {
  var className = _ref3.className,
    mimeType = _ref3.mimeType,
    _ref3$versions = _ref3.versions,
    w640 = _ref3$versions.w640,
    original = _ref3$versions.original,
    mp4 = _ref3$versions.mp4,
    ts = _ref3$versions.ts,
    webm = _ref3$versions.webm,
    props = _objectWithoutProperties(_ref3, _excluded);
  // due to syntactic event, we need to hook into the native
  // event. that's because wrapping containers (like <a>) could
  // handle the click, which for video, we do not allow.
  // if you need to: use managed events like "onPlay" instead.
  var clickTrapDiv = useEventListener("click", function (e) {
    return void e.preventDefault();
  });
  var src = mimeType.startsWith("video/x-") ? original : mapVersionToSourceList({
    mp4: mp4,
    ts: ts,
    webm: webm
  });
  var __customPropPleaseFixSoon = {};
  // facebook specific modification
  if (mimeType === "video/x-facebook" && typeof src === "string") {
    __customPropPleaseFixSoon["__isFacebook__"] = true;
    src = "//www.facebook.com/video.php?v=" + src.match(/\d+/)[0];
  }
  return /*#__PURE__*/_jsx("div", {
    className: className,
    ref: clickTrapDiv,
    children: /*#__PURE__*/_jsx(Video, _objectSpread(_objectSpread({}, props), {}, {
      thumb: w640,
      src: src
    }, __customPropPleaseFixSoon))
  });
};
export default AssetVideo;
//# sourceMappingURL=Video.js.map